import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import * as PropTypes from 'prop-types';

const DialogType = Object.freeze({
  none: 0,
  releaseToAll: 1,
  releaseGroup: 2,
  releaseToOffice: 3,
  releaseConfirmation: 4,
});

export default class ReleaseObjectsDialog extends Component {
  getDialogHeader() {
    const { currentDialogType } = this.props;
    switch (currentDialogType) {
      case DialogType.releaseToAll:
        return 'Öffentlich freigeben';
      case DialogType.releaseGroup:
        return 'Gruppenintern freigeben';
      case DialogType.releaseToOffice:
        return 'Amtsintern freigeben';
      case DialogType.releaseConfirmation:
        return 'Bestätigung';
      default:
        return 'Ungültiger Typ';
    }
  }

  getDialogText() {
    const { currentDialogType, currentNode } = this.props;
    switch (currentDialogType) {
      case DialogType.releaseToAll:
        return <h3>{`Möchten Sie '${currentNode.name}' wirklich öffentlich freigeben?`}</h3>;
      case DialogType.releaseGroup:
        return <h3>{`Möchten Sie '${currentNode.name}' wirklich gruppenintern freigeben?`}</h3>;
      case DialogType.releaseToOffice:
        return <h3>{`Möchten Sie '${currentNode.name}' wirklich amtsintern freigeben?`}</h3>;
      case DialogType.releaseConfirmation:
        return <h3>{`Sollen mit der Freigabe des Objekts auch alle Merkmalsausprägungen freigegeben werden?`}</h3>;
      default:
        return 'Ungültiger Typ';
    }
  }

  getDialogConfirmButtonText() {
    const { currentDialogType } = this.props;
    switch (currentDialogType) {
      case DialogType.releaseGroup:
        return 'Freigeben';
      case DialogType.releaseToAll:
        return 'Freigeben';
      case DialogType.releaseToOffice:
        return 'Freigeben';
      case DialogType.releaseConfirmation:
        return 'Freigeben';
      default:
        return 'Ungültiger Typ';
    }
  }

  renderFooter(currentDialogType) {
    const { confirmDialog, rejectDialog, onHide } = this.props;
    return (
      <div>
        <Button
          id="continue"
          /* disabled={!this.isButtonEnabled()} */
          label={this.getDialogConfirmButtonText()}
          className="p-button-success"
          icon="pi pi-check"
          onClick={confirmDialog}
        />
        {currentDialogType === DialogType.releaseConfirmation ?
          (
            <Button
              id="reject"
              /* disabled={!this.isButtonEnabled()} */
              label="Nicht freigeben"
              className="p-button-warning"
              icon="pi pi-angle-right"
              onClick={rejectDialog}
            />
          ) : undefined
        }
        <Button
          default
          id="cancel"
          label="Abbrechen"
          className="p-button-danger"
          icon="pi pi-times"
          onClick={() => { onHide(); }}
        />
      </div>
    );
  }

  render() {
    const { currentDialogType, onHide } = this.props;
    console.log('DIALOGTYPE#', currentDialogType)
    return (
      <Dialog
        header={this.getDialogHeader(currentDialogType)}
        visible={currentDialogType}
        style={{ width: '42rem' }}
        footer={this.renderFooter(currentDialogType)}
        onHide={() => onHide()}
        modal
      >
        <div>
          {this.getDialogText(currentDialogType)}
        </div>
      </Dialog>
    );
  }
}

ReleaseObjectsDialog.propTypes = {
  onHide: PropTypes.func.isRequired,
  currentDialogType: PropTypes.number.isRequired,
  confirmDialog: PropTypes.func.isRequired,
  rejectDialog: PropTypes.func.isRequired,
  currentNode: PropTypes.instanceOf(Object).isRequired,
};
